var _style, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgAkash(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "akash_svg__Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 30.4 26.6",
    xmlSpace: "preserve",
    width: "1em",
    height: "1em"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".akash_svg__st0{fill-rule:evenodd;clip-rule:evenodd;fill:#ed3524}")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "akash_svg__Page-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "akash_svg__R15_Mobile_Home",
    transform: "translate(-172 -62)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "akash_svg__Top"
  }, /*#__PURE__*/React.createElement("g", {
    id: "akash_svg__Group-20",
    transform: "translate(17 61)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "akash_svg__akash-logo",
    transform: "translate(155 1)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "akash_svg__Fill-11",
    className: "akash_svg__st0",
    d: "M9.9 0l15.4 26.6 5.1-8.9L20.1 0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "akash_svg__Fill-12",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#ae1e23",
    d: "M9.9 18.2l5.3 8.4h10.6l-5.3-8.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "akash_svg__Fill-13",
    className: "akash_svg__st0",
    d: "M5.3 8.4L0 17.5l5.3 9.1L16 8.4z"
  }))))))));
}

export default SvgAkash;